import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DestCard } from '../components/Cards';
import { DEST_REGIONS, inferRegion } from '../data';
import { usePackages } from '../hooks/usePackages';
import destinationsBanner from '../assets/logo/Explore the World by Sea.png';

export default function Destinations() {
  const [activeRegion, setActiveRegion] = useState('India');
  const navigate = useNavigate();
  const { packages } = usePackages();

  const regionPackages = packages.filter(pkg => {
    const pkgRegion = pkg.region || inferRegion(pkg);
    return pkgRegion.toLowerCase() === activeRegion.toLowerCase();
  });

  // Split into categories
  const holidays = regionPackages.filter(p => p.cat?.toLowerCase() !== 'city');
  const cityBreaks = regionPackages.filter(p => p.cat?.toLowerCase() === 'city');

  return (
    <div className="page-enter">
      {/* Hero Banner */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          background: '#0d1117',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        }}
      >
        <img
          src={destinationsBanner}
          alt="Explore the World - All Destinations"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '440px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 32px' }}>

        {/* Region tabs */}
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '36px' }}>
          {DEST_REGIONS.map(r => (
            <button
              key={r}
              onClick={() => setActiveRegion(r)}
              className={`filter-btn ${activeRegion === r ? 'active' : ''}`}
            >
              {r}
            </button>
          ))}
        </div>

        {/* Popular Holidays */}
        {holidays.length > 0 && (
          <>
            <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#0d1117', marginBottom: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              ☀️ Popular Holidays
            </h3>
            <div className="destinations-grid-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '16px', marginBottom: '40px' }}>
              {holidays.map(d => <DestCard key={d.name} {...d} onClick={() => navigate(`/package/${d.name}`)} />)}
            </div>
          </>
        )}

        {/* City Breaks */}
        {cityBreaks.length > 0 && (
          <>
            <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#0d1117', marginBottom: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              🏙️ City Breaks
            </h3>
            <div className="destinations-grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '14px' }}>
              {cityBreaks.map(d => <DestCard key={d.name || d.city} {...d} name={d.name || d.city} onClick={() => navigate(`/package/${d.name || d.city}`)} />)}
            </div>
          </>
        )}

        {regionPackages.length === 0 && (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6b7a8f' }}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>🗺</div>
            <div style={{ fontSize: '16px', fontWeight: 600 }}>No packages found in this region</div>
            <div style={{ fontSize: '13px', marginTop: '6px' }}>We are constantly expanding our destinations list!</div>
          </div>
        )}
      </div>
    </div>
  );
}
